import request, { METHODS } from "src/utils/api-base";

const authTenantApis = {
  login: (payload: { email: string; password: string }) => {
    return request({
      route: "/app/auth/login",
      method: METHODS.POST,
      payload,
    });
  },
  getUserDetails: () =>
    request({
      route: "/app/auth/get-user-info",
      method: METHODS.GET,
      auth: true,
    }),
  updateProfile: (payload: {
    firstName: string;
    lastName?: string;
    email: string;
    password?: string;
  }) =>
    request({
      route: "/app/auth/update-profile",
      method: METHODS.PUT,
      payload,
      auth: true,
    }),
  getPlanUsage: () =>
    request({
      route: "/app/auth/plan-usage",
      method: METHODS.GET,
      auth: true,
    }),
};

export default authTenantApis;
